export function formatDate(timestamp: number | string, withTime: boolean = false) {
  const date = new Date(Number(timestamp) * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");


  if (withTime) {
    return `${day}.${month}.${year}, ${hours}:${minutes}`;
  } else {
    return `${day}.${month}.${year}`;
  }
}